// Web push for the Dev Console's away mode: register public/sw.js, subscribe
// with the instance's VAPID key (GET /dev/push/key) and hand the
// subscription to the backend (shared/devNotify.js). Degrades to nothing
// where push is unsupported (iOS Safari outside Add-to-Home-Screen) or the
// instance has no keys — tab notifications still work.
const b64ToBytes = (s) => {
  const pad = '='.repeat((4 - (s.length % 4)) % 4);
  const raw = atob((s + pad).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

export const pushSupported = () => typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

export async function enablePush(api) {
  if (!pushSupported()) return { ok: false, reason: 'unsupported' };
  const { enabled, key } = await api('/dev/push/key');
  if (!enabled || !key) return { ok: false, reason: 'no-key' };
  const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToBytes(key) });
  await api('/dev/push/subscribe', { subscription: sub.toJSON() });
  return { ok: true, endpoint: sub.endpoint };
}

export async function disablePush(api) {
  if (!pushSupported()) return { ok: true };
  const reg = await navigator.serviceWorker.getRegistration('/');
  const sub = await reg?.pushManager.getSubscription();
  if (sub) {
    await api('/dev/push/unsubscribe', { endpoint: sub.endpoint }).catch(() => {});
    await sub.unsubscribe().catch(() => {});
  }
  return { ok: true };
}
